
import { Types } from "./actionTypes";
import { MONITOR_PARAMETER, RESP_OBJ, PLETH_OBJ } from '../../common/constant/common-constants'; // adjust path


const Ecg_keys = [
    MONITOR_PARAMETER.HR.toString(),
    MONITOR_PARAMETER.RR.toString()
];

const Spo2_keys = [
    MONITOR_PARAMETER.SPO2.toString(),
    MONITOR_PARAMETER.SPO2_PERFUSION_INDEX.toString(),
    MONITOR_PARAMETER.SPO2_PULSE_RATE.toString()
];

const NIBP_keys = [
    MONITOR_PARAMETER.NIBP_SYSTOLIC.toString(),
    MONITOR_PARAMETER.NIBP_DIASTOLIC.toString(),
    MONITOR_PARAMETER.NIBP_MEAN.toString(),
    MONITOR_PARAMETER.NIBP_PULSE_RATE.toString()
];

const Temp_keys = [
    MONITOR_PARAMETER.TEMPERATURE_1.toString(),
    MONITOR_PARAMETER.TEMPERATURE_2.toString(),
    MONITOR_PARAMETER.TEMPERATURE_DIFF.toString()
];

const Resp_graph_keys = [RESP_OBJ.id.toString()];
const Spo2_graph_keys = [PLETH_OBJ.id.toString()];

export const bedDetailAction = (task) => {

    return {
        type: Types.BED_DETAILS,
        payload: task
    }
}

export const bedIdAction = (task) => {

    return {
        type: Types.BED_ID_ARRAY,
        payload: task
    }
}

export const hospitalDataAction = (task) => {

    return {
        type: Types.HOSPITAL_DATA,
        payload: task
    }
}


export const sidebarActiveIconAction = (task) => {
    return {
        type: Types.SIDEBAR_ACTIVE_ICON,
        payload: task,
    }
}

export const activeDeviceAction = (task) => {
    console.log("activeDeviceAction_action---------------_>", task)
    return {
        type: Types.ACTIVE_DEVICE,
        payload: task,
    }
}

export const wardDetailsAction = (task) => {

    return {
        type: Types.WARD_DATA,
        payload: task
    }
}

export const patientDataAction = (task) => {

    return {
        type: Types.PATIENT_DATA,
        payload: task
    }
}
export const patienDischargeAction = (task) => {
    return {
        type: Types.PATIENT_DISCHARGE,
        payload: task
    }
}


// Action for putting DB data(vitals) in reducer during sign-out/refresh

export const deviceVitalDataAction_DB_NIBP = (task) => {
    if (task?.monitorParameter?.nibp) {

        let nibpTask = {
            bedId: task.bedId,
            deviceId: task.monitorParameter.noccarcPatientMonitorId,
            deviceType: "NOCCARC_PM_NX5",
            monitorParameter: task.monitorParameter.nibp

        }
        return {
            type: Types.DEVICE_VITAL_DATA_NIBP,
            payload: nibpTask
        }




    }

}
export const deviceVitalDataAction_DB_TEMP = (task) => {

    if (task?.monitorParameter?.temp) {

        let tempTask = {
            bedId: task.bedId,
            deviceId: task.monitorParameter.noccarcPatientMonitorId,
            deviceType: "NOCCARC_PM_NX5",
            monitorParameter: task.monitorParameter.temp

        }

        return {
            type: Types.DEVICE_VITAL_DATA_TEMP,
            payload: tempTask
        }

    }

}
export const deviceVitalDataAction_DB_SPO2 = (task) => {

    if (task?.monitorParameter?.spo2) {

        let spo2Task = {
            bedId: task.bedId,
            deviceId: task.monitorParameter.noccarcPatientMonitorId,
            deviceType: "NOCCARC_PM_NX5",
            monitorParameter: task.monitorParameter.spo2



        }

        return {
            type: Types.DEVICE_VITAL_DATA_SPO2,
            payload: spo2Task
        }


    }
}
export const deviceVitalDataAction_DB_ECG = (task) => {

    if (task?.monitorParameter?.ecg) {

        let ecgTask = {
            bedId: task.bedId,
            deviceId: task.monitorParameter.noccarcPatientMonitorId,
            deviceType: "NOCCARC_PM_NX5",
            monitorParameter: task.monitorParameter.ecg

        }

        return {
            type: Types.DEVICE_VITAL_DATA_ECG,
            payload: ecgTask
        }



    }
}


// Action for putting data(vitals) from socket(live) in reducer
export const deviceVitalDataAction = (task) => {
    // console.log("Action of Monitor_params------------------>" ,task);

    const packet_Keys = task.monitorParameter
    // console.log(packet_Keys)
    const is_ECG_parmas = Ecg_keys.every(key => key in packet_Keys);
    const is_NIBP_params = NIBP_keys.every(key => key in packet_Keys);
    const is_Temp_parmas = Temp_keys.every(key => key in packet_Keys);
    const is_Spo2_params = Spo2_keys.every(key => key in packet_Keys);

    // console.log(is_ECG_parmas)
    // console.log(is_Spo2_params)




    if (is_ECG_parmas) {
        return {
            type: Types.DEVICE_VITAL_DATA_ECG,
            payload: task
        }

    }
    else if (is_NIBP_params) {
        return {
            type: Types.DEVICE_VITAL_DATA_NIBP,
            payload: task
        }

    }
    else if (is_Temp_parmas) {
        return {
            type: Types.DEVICE_VITAL_DATA_TEMP,
            payload: task
        }

    }
    else if (is_Spo2_params) {
        return {
            type: Types.DEVICE_VITAL_DATA_SPO2,
            payload: task
        }

    }


}

export const monitorHeartbeatAction = (task) => {
    return {
        type: Types.MONITOR_HEARTBEAT_DATA,
        payload: task
    }
}


export const deviceEcgWaveformDataAction = (task) => {
    // console.log("task::::::::::::::", task)
    return {
        type: Types.DEVICE_ECG_WAVEFORM_DATA,
        payload: task
    }
}

export const deviceHrWaveformDataAction = (task) => {
    // console.log("deviceHrWaveformDataAction------------------>", task);
    const packet_Keys = task.secondaryWaveforms

    const is_Resp_parmas = Resp_graph_keys.every(key => key in packet_Keys);
    const is_Pleth_params = Spo2_graph_keys.every(key => key in packet_Keys);

    if (is_Resp_parmas) {
        return {
            type: Types.DEVICE_RESP_WAVEFORM_DATA,
            payload: task
        }

    }
    else if (is_Pleth_params) {
        return {
            type: Types.DEVICE_PLETH_WAVEFORM_DATA,
            payload: task
        }

    }


}

export const alarmDataAction = (task) => {

    // console.log("PM_noccarc_Alarms------------------------------>", task)
    return {
        type: Types.NOCCARC_PM_ALARM_DATA,
        payload: task
    }
}

export const ventilatorAlarmDataAction = (task) => {
    return {
        type: Types.VENTILATOR_ALARM_DATA,
        payload: task
    }
}

export const ventilatorHeartbeatAction = (task) => {
    return {
        type: Types.VENTILATOR_HEARTBEAT_DATA,
        payload: task
    }
}

export const notificationDataAction = (task) => {

    return {
        type: Types.NOTIFICATION_DATA,
        payload: task
    }
}

export const viewTypeAction = (task) => {

    return {
        type: Types.CONFIG_VIEW_TYPE,
        payload: task
    }
}

export const filterAction = (task) => {

    return {
        type: Types.CONFIG_FILTER_TYPE,
        payload: task
    }
}

export const modalAction = (task) => {

    return {
        type: Types.CONFIG_MODAL,
        payload: task
    }
}

export const favoriteBedAction = (task) => {

    return {
        type: Types.FAVORITE_BED_ID_ARRAY,
        payload: task
    }
}

export const bedDetailConfigAction = (task) => {

    return {
        type: Types.CONFIG_BED_DETAILS,
        payload: task
    }
}

export const addColumnBedListAction = (task) => {

    return {
        type: Types.CONFIG_ADD_COLUMN,
        payload: task
    }
}

export const removeColumnBedListAction = (task) => {

    return {
        type: Types.CONFIG_REMOVE_COLUMN,
        payload: task
    }
}

export const clearAlarms = () => {

    return {
        type: Types.CLEAR_ALARM,
        payload: null
    }
}

export const clearBedAlarm = (task) => {
    return {
        type: Types.CLEAR_BED_ALARM,
        payload: task,
    }
}

export const clearStore = () => {

    return {
        type: Types.CLEAR_STORE,
        payload: null
    }
}

export const selectedBedAction = (task) => {
    return {
        type: Types.SELECTED_BED,
        payload: task
    }
}

export const selectedWardAction = (task) => {
    return {
        type: Types.SELECTED_WARD,
        payload: task
    }
}

export const ventilatorVitalDataAction = (task) => {
    console.log("ventilatorVitalDataAction task", task);
    return {
        type: Types.VENTILATOR_VITAL_DATA,
        payload: task,
        // {
        //     "hospitalId": 1,
        //     "wardId": 1,
        //     "bedId": 9,
        //     "deviceId": 85,
        //     "deviceType": "VENTILATORV730i",
        //     "channelName": "ventilator_monitor_data",
        //     "monitorsData": {
        //         "c_stat": {
        //             "alarms": [],
        //             "id": 104013,
        //             "key": "c_stat",
        //             "value": 22.75
        //         },
        //         "cal_param_mvi": {
        //             "alarms": [],
        //             "id": 104032,
        //             "key": "cal_param_mvi",
        //             "value": task?.monitorsData?.cal_param_mvi?.value
        //         },
        //         "cal_param_pmean": {
        //             "alarms": [],
        //             "id": -1,
        //             "key": "cal_param_pmean",
        //             "value": 810
        //         },
        //         "cal_param_spmve": {
        //             "alarms": [],
        //             "id": 104033,
        //             "key": "cal_param_spmve",
        //             "value": 6.678
        //         },
        //         "capno_param_petco2": {
        //             "alarm_limit": [
        //                 30,
        //                 50,
        //                 true,
        //                 true
        //             ],
        //             "alarms": []
        //         },
        //         "cdyn": {
        //             "alarms": [],
        //             "id": 104016,
        //             "key": "cdyn",
        //             "value": 24.12
        //         },
        //         "e": {
        //             "alarms": [],
        //             "id": 104004,
        //             "key": "e",
        //             "value": 2000
        //         },
        //         "fio2": {
        //             "alarm_limit": [
        //                 60,
        //                 70,
        //                 true,
        //                 true
        //             ],
        //             "alarms": [],
        //             "id": 104001,
        //             "key": "fio2",
        //             "value": 55
        //         },
        //         "flow_neg": {
        //             "alarms": [],
        //             "id": 104011,
        //             "key": "flow_neg",
        //             "value": -3783
        //         },
        //         "flow_rate": {
        //             "alarm_limit": [
        //                 10,
        //                 60,
        //                 true,
        //                 true
        //             ],
        //             "alarms": [],
        //             "id": 104023,
        //             "key": "flow_rate",
        //             "value": 0
        //         },
        //         "flowee": {
        //             "alarms": [],
        //             "id": 104012,
        //             "key": "flowee",
        //             "value": 0
        //         },
        //         "i": {
        //             "alarms": [],
        //             "id": 104003,
        //             "key": "i",
        //             "value": 1000
        //         },
        //         "leakage": {
        //             "alarms": [],
        //             "id": 104034,
        //             "key": "leakage",
        //             "value": 1
        //         },
        //         "mve": {
        //             "alarm_limit": [
        //                 0,
        //                 15,
        //                 false,
        //                 true
        //             ],
        //             "alarms": [],
        //             "id": 104031,
        //             "key": "mve",
        //             "value": 5769
        //         },
        //         "p_0_1": {
        //             "alarms": [],
        //             "id": 104015,
        //             "key": "p_0_1",
        //             "value": 0
        //         },
        //         "para_cpap": {
        //             "alarms": [],
        //             "id": 104018,
        //             "key": "para_cpap",
        //             "value": 0
        //         },
        //         "pdrive": {
        //             "alarms": [],
        //             "id": 104017,
        //             "key": "pdrive",
        //             "value": 0
        //         },
        //         "peep": {
        //             "alarm_limit": [
        //                 2,
        //                 10,
        //                 true,
        //                 true
        //             ],
        //             "alarms": [],
        //             "id": 104007,
        //             "key": "peep",
        //             "value": 4.6
        //         },
        //         "perfusion_index": {
        //             "alarms": [],
        //             "id": 104025,
        //             "key": "perfusion_index"
        //         },
        //         "pip": {
        //             "alarm_limit": [
        //                 1,
        //                 40,
        //                 false,
        //                 true
        //             ],
        //             "alarms": [],
        //             "id": 104006,
        //             "key": "pip",
        //             "value": 18
        //         },
        //         "pleth": {
        //             "alarms": [],
        //             "id": 104026,
        //             "key": "pleth"
        //         },
        //         "pplat": {
        //             "alarms": [],
        //             "id": 104005,
        //             "key": "pplat",
        //             "value": 17
        //         },
        //         "pulse_rate": {
        //             "alarm_limit": [
        //                 50,
        //                 120,
        //                 true,
        //                 true
        //             ],
        //             "alarms": [],
        //             "id": 104024,
        //             "key": "pulse_rate"
        //         },
        //         "pwob": {
        //             "alarms": [],
        //             "id": 104022,
        //             "key": "pwob"
        //         },
        //         "r_static": {
        //             "alarms": [],
        //             "id": 104014,
        //             "key": "r_static",
        //             "value": 7
        //         },
        //         "re": {
        //             "alarms": [],
        //             "id": -1,
        //             "key": "re",
        //             "value": 6
        //         },
        //         "rr": {
        //             "alarm_limit": [
        //                 12,
        //                 28,
        //                 true,
        //                 true
        //             ],
        //             "alarms": [],
        //             "id": 104002,
        //             "key": "rr",
        //             "value": 20
        //         },
        //         "rrs": {
        //             "alarms": [],
        //             "id": 104019,
        //             "key": "rrs",
        //             "value": 0
        //         },
        //         "spo2": {
        //             "alarm_limit": [
        //                 85,
        //                 100,
        //                 true,
        //                 true
        //             ],
        //             "alarms": [],
        //             "id": 104021,
        //             "key": "spo2"
        //         },
        //         "static_maneuver_compliance": {
        //             "alarms": [],
        //             "id": -1,
        //             "key": "static_maneuver_compliance",
        //             "value": 0
        //         },
        //         "static_maneuver_platue": {
        //             "alarms": [],
        //             "id": -1,
        //             "key": "static_maneuver_platue",
        //             "value": 0
        //         },
        //         "stress_index": {
        //             "alarms": [],
        //             "id": -1,
        //             "key": "stress_index",
        //             "value": 84
        //         },
        //         "vte": {
        //             "alarm_limit": [
        //                 0,
        //                 4000,
        //                 false,
        //                 false
        //             ],
        //             "alarms": [],
        //             "id": 104009,
        //             "key": "vte",
        //             "value": 272
        //         },
        //         "vti": {
        //             "alarms": [],
        //             "id": 104008,
        //             "key": "vti",
        //             "value": 279
        //         },
        //         "vts": {
        //             "alarms": [],
        //             "id": 104010,
        //             "key": "vts",
        //             "value": 100
        //         },
        //         "wob_event": {
        //             "alarms": [],
        //             "id": -1,
        //             "key": "wob_event",
        //             "value": 302
        //         },
        //         "wobi": {
        //             "alarms": [],
        //             "id": -1,
        //             "key": "wobi",
        //             "value": 0
        //         }
        //     }
        // },
    }
}

export const ventilatorStandbyDataAction = (task) => {
    return {
        type: Types.VENTILATOR_STANDBY_DATA,
        payload: task,
    }
}

export const ventilatorModesDataAction = (task) => {
    return {
        type: Types.VENTILATOR_MODES_DATA,
        payload: task,
    }
}

export const ventilatorWaveformDataAction = (task) => {
    return {
        type: Types.VENTILATOR_WAVEFORM_DATA,
        payload: task,
    }
}